module.exports = __webpack_public_path__ + "static/media/jobreel.81f9f901.jpg";